/** Maximum length of damage notes / failure notes. */
export const EQUIPMENT_NOTES_MAX_LENGTH = 1000;
/** The live character counter appears once this many characters remain. */
export const EQUIPMENT_NOTES_COUNTER_THRESHOLD = 100;

/**
 * Strips executable markup from free text so it is stored and displayed as plain text.
 * Removes script/style blocks (with their content), HTML comments, any remaining tags,
 * and javascript:/vbscript: URL schemes, then trims and enforces the max length.
 */
export const sanitizeFreeText = (value?: string, maxLength: number = EQUIPMENT_NOTES_MAX_LENGTH): string => {
  if (!value) return "";
  let text = value;
  let previous: string;
  do {
    previous = text;
    text = text
      .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, "")
      .replace(/<!--[\s\S]*?-->/g, "")
      .replace(/<\/?[a-z!][^>]*>/gi, "")
      .replace(/\b(?:javascript|vbscript)\s*:/gi, "");
  } while (text !== previous);
  return text.trim().slice(0, maxLength);
};
